import { PersonDto } from '../services/api';

const EN_DASH = '\u2013';

const formatYear = (dateValue?: string) => {
  if (!dateValue) {
    return '';
  }

  const parsedDate = new Date(dateValue);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  return parsedDate.getUTCFullYear().toString();
};

export const buildCanvasPersonLabel = (
  person: Pick<PersonDto, 'firstName' | 'lastName' | 'isDeceased' | 'dateOfBirth' | 'dateOfDeath'>
) => {
  const baseName = `${person.firstName}\n${person.lastName}`;

  if (!person.isDeceased) {
    return baseName;
  }

  const birthYear = formatYear(person.dateOfBirth);
  const deathYear = formatYear(person.dateOfDeath);
  const lifespan = birthYear || deathYear ? `\n${birthYear || '?'}${EN_DASH}${deathYear || '?'}` : '';

  return `${baseName}${lifespan}`;
};

export const getCanvasPersonVisualState = (
  person: Pick<PersonDto, 'gender' | 'isDeceased'>
) => {
  const genderLower = person.gender?.toLowerCase() || 'unspecified';

  const borderColor = (() => {
    if (person.isDeceased) {
      return '#B08A75';
    }

    switch (genderLower) {
      case 'male':
        return '#2563eb';
      case 'female':
        return '#ec486b';
      case 'other':
      case 'unspecified':
      default:
        return '#6b7280';
    }
  })();

  return {
    borderColor,
    statusTextColor: person.isDeceased ? '#6B5A50' : '#1f2937',
    borderStyle: person.isDeceased ? 'dashed' : 'solid',
    backgroundBlacken: person.isDeceased ? 0.14 : 0,
    opacity: person.isDeceased ? 0.9 : 1,
    isDeceased: person.isDeceased ? 1 : 0,
  } as const;
};
